/* eslint-disable no-underscore-dangle */
import EventEmitter from 'events';
import createRecoveryCongestionLevelCalculatorDefault from './recoveryCongestionLevelCalculator';
import { CRITICAL, LOW } from '../congestionLevels';
import createLogger from '../../../../helpers/log';

const logger = createLogger('networkProbe');

const MAX_MEASUREMENTS = 20;

const createNetworkProbe = (deps = {}) => {
  const ee = new EventEmitter();
  const {
    getStats,
    createRecoveryCongestionLevelCalculator = createRecoveryCongestionLevelCalculatorDefault,
  } = deps;

  let measurementCount = 0;
  const congestionLevelCalculator = createRecoveryCongestionLevelCalculator({ getStats });

  const stopProbeWithResult = (result) => {
    congestionLevelCalculator.stop();
    logger.info(`Network probe result ${result}`);
    ee.emit('probeResult', result);
  };

  congestionLevelCalculator.on('congestionLevel', (congestionLevel) => {
    measurementCount += 1;
    if (congestionLevel === CRITICAL) {
      // We stop probing immediately if we get a CRITICAL result
      stopProbeWithResult(CRITICAL);
    } else if (measurementCount >= MAX_MEASUREMENTS) {
      if (congestionLevel === LOW) {
        stopProbeWithResult(LOW);
      } else {
        // final measurement result was MEDIUM so we keep CRITICAL level
        stopProbeWithResult(CRITICAL);
      }
    }
  });

  return Object.assign(ee, {
    start() {
      logger.info('Start network probe');
      congestionLevelCalculator.start();
    },
    stop() {
      logger.info('Stop network probe');
      congestionLevelCalculator.stop();
      measurementCount = 0;
    },
  });
};

export default createNetworkProbe;
